import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IBINDataTableRowFormMeta {
  minRank: FormInputMeta,
  maxRank: FormInputMeta,
  issuerBin: FormInputMeta,
  chk: FormInputMeta,
  panLg: FormInputMeta,  
  processingID: FormInputMeta,
  domain: FormInputMeta,
  region: FormInputMeta,
  tech: FormInputMeta,
  riss: FormInputMeta,
  ciss: FormInputMeta,
  ctn: FormInputMeta,
  usage: FormInputMeta,
  cardIn: FormInputMeta,
  //
  cardUsage: FormInputMeta,
  networkCardType: FormInputMeta,
  domainName: FormInputMeta,
  country: FormInputMeta,
  
  schema: any,
}

const BINDataTableRowFormMeta = {} as IBINDataTableRowFormMeta;

BINDataTableRowFormMeta.minRank = {
  name: 'minRank',
  type: 'text',
  label: 'Rang Min',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.maxRank = {
  name: 'maxRank',
  type: 'text',
  label: 'TC',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.issuerBin = {
  name: 'issuerBin',
  type: 'text',
  label: 'Issuer Bin',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.chk = {
  name: 'chk',
  type: 'text',
  label: 'Chk',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.panLg = {
  name: 'panLg',
  type: 'text',
  label: 'Pan Lg',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.processingID = {
  name: 'processingID',
  type: 'text',
  label: 'Proc ID',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.domain = {
  name: 'domain',
  type: 'text',
  label: 'Domaine',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.region = {
  name: 'region',
  type: 'text',
  label: 'Region',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.tech = {
  name: 'tech',
  type: 'text',
  label: 'Tech',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.riss = {
  name: 'riss',
  type: 'text',
  label: 'RISS',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.ciss = {
  name: 'ciss',
  type: 'text',
  label: 'CISS',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.ctn = {
  name: 'ctn',
  type: 'text',
  label: 'Ctn',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.usage = {
  name: 'usage',
  type: 'text',
  label: 'Usage',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.cardIn = {
  name: 'cardIn',
  type: 'text',
  label: 'Card In',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};

// *********************************************

BINDataTableRowFormMeta.cardUsage = {
  name: 'cardUsage',
  type: 'text',
  label: 'Utilisation Carte',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.networkCardType = {
  name: 'networkCardType',
  type: 'text',
  label: 'Type carte reseau',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.domainName = {
  name: 'domainName',
  type: 'text',
  label: 'Domaine',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
BINDataTableRowFormMeta.country = {
  name: 'country',
  type: 'text',
  label: 'Pays',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};

BINDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(BINDataTableRowFormMeta));

export default BINDataTableRowFormMeta;
